<template>
  <v-expansion-panels v-model="panel">
    <v-expansion-panel>
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row no-gutters>
            <v-col cols="3">Parametri</v-col>
            <v-col cols="8" class="text--secondary">
              <span  v-if="open" key="0">Imposta i parametri della lettura</span>
              <span v-else key="1">
                {{ settore }} | {{ noteLettura }} | {{ dataFormatted }} | {{nomeFile}}
              </span>
            </v-col>
            <v-col cols="12" sm="6" class="d-none d-md-block"></v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row justify="start" dense>
          <v-col md="2" lg="2">
            <v-select v-model="tipoFile" :items="tipiFile" outlined dense label="Tipo file" item-value="codice" item-text="codice" :hint="descrizioneTipo(tipoFile)" persistent-hint></v-select>
          </v-col>
          <v-col v-if="tipoFile==='Memory'" xs="12" sm="12" md="6" lg="4">
            <memory :resetFile="triggerReset" @onLoaded="onloaded" @onLoadedArray="onLoadedArray"/>
          </v-col>
          <v-col v-if="tipoFile==='Excel' || tipoFile==='Excel-C' || tipoFile==='Excel-T-C'" cols="12" lg="9" md="10" sm="12">
            <excel :resetFile="triggerReset" :tipo="tipoFile" @onLoaded="onloaded" @onLoadedArray="onLoadedArray" @startLoading="localLoading=true"/>
          </v-col>
          <v-col v-if="tipoFile==='Terminale Online'" xs="12" sm="12" md="8" lg="8">
            <terminale-online :loading="loadingSearch" @cerca-movimenti="onCercaMovimenti"/>
          </v-col>
          <v-col md="1">
            <v-btn @click.stop="onPulisci" :disabled="pulisciDisabled" outlined>Pulisci</v-btn>
          </v-col>
        </v-row>
        <v-row justify="start" dense>
          <v-col cols="12" lg="4" md="6" sm="12">
            <!-- <v-select v-model="modelloProdotto" :items="modelliProdotto" dense flat outlined label="Modello" item-text="descrizione" item-value="codice" clearable :return-object="true" @change="onChangeModello"></v-select> -->
            <v-combobox v-model="settore" :items="settoriInseriti" label="Settore" outlined dense clearable @change="onChangeSettore"></v-combobox>
          </v-col>
         <v-col cols="12" lg="4" md="6" sm="12">
            <v-text-field v-model="noteLettura" dense outlined required label="Note" clearable></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="start" dense>
          <v-col cols="12" lg="4" md="6" sm="12">
            <v-menu
              v-model="menuStart"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="computedDataFormatted"
                  label="Data"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  @click:clear="dataLettura = null"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dataLettura" no-title scrollable @input="menuStart = false"></v-date-picker>
            </v-menu>
          </v-col>          
<!--           <v-col cols="12" sm="6">
            <excel :resetFile="triggerReset" @onLoaded="onloaded"/>
          </v-col> -->
<!--           <v-col>
            <v-btn @click.stop="onPulisci" :disabled="pulisciDisabled" outlined>Pulisci</v-btn>
          </v-col>    -->       
<!--           <v-spacer/> -->
          <v-col>
            <v-btn :loading="loading || localLoading" @click.stop="onImporta" :disabled="importaDisabled">Importa letture</v-btn>
          </v-col>          
        </v-row>
        <dialog-conferma
          :show="dialogConferma"
          title="Confermi import lettura ?"
          :message="''"
          @dialog-confirm="eseguiImporta"
          @dialog-cancel="dialogConferma=false"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  import DialogConferma from '@/components/dialogConferma'
  import Excel from './excel.vue'
  import Memory from './memory.vue'
  import TerminaleOnline from './terminaleOnline.vue'

  export default {
    components: {
      Excel,
      DialogConferma,
      Memory,
      TerminaleOnline
    },
    props: {
      loading: Boolean,
      loadingCategorie: Boolean,
      pulisci: Number
    },
    data: (vm) => ({
      panel: 0,
      settoriInseriti: [],
      fornitori: [],
      dataFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dataLettura: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      settore: null,
      noteLettura: '',
      menuStart: false,
      modal: false,
      mostaRaw: false,
      totaleDati: 0,
      nomeFile: '',
      dialogConferma: false,
      triggerReset: 0,
      tipoFile: '',
      tipiFile_old: ['Excel', 'Excel C', 'Excel-T-C', 'Memory', 'Terminale Online'],
      tipiFile: [
        { codice: 'Excel', descrizione: 'Excel, campo chiave: barcode' },
        { codice: 'Excel-C', descrizione: 'Excel, campo chiave: codice' },
        { codice: 'Excel-T-C', descrizione: 'Excel, campo chiave: codice, taglia, colore' },
        { codice: 'Memory', descrizione: 'File generato con dispositivo Memory' },
        { codice: 'Terminale Online', descrizione: 'Acquisizione da Terminale Online' }
      ],
      localLoading: false,
      loadingSearch: false
    }),
    async mounted() {
    },
    computed: {
      computedDataFormatted () {
        return this.formatDate(this.dataLettura)
      },
      importaDisabled() {
        return (!this.settore) || (this.totaleDati === 0 && this.tipoFile !== 'Terminale Online')
      },
      pulisciDisabled() {
        return this.loading || this.loadingCategorie
      }
    },
    watch: {
      dataLettura (val) {
        this.dataFormatted = this.formatDate(this.dataLettura)
      },
      mostaRaw(val) {
        this.$emit('cambiaVista', val)
      },
      pulisci() {
        this.onPulisci()
      }
    },
    methods: {
      descrizioneTipo(tipoFile) {
        return tipoFile ? this.tipiFile.find(x => x.codice === tipoFile).descrizione : ''
      },
      onloaded(dati) {
        this.totaleDati = dati ? dati.datiRaw.length : 0
        if (!this.settore && dati) {
          const nn = dati.nomeFile.split('.')
          nn.pop()
          this.settore = nn.join('.')
          this.onChangeSettore()
        }
        this.nomeFile = dati ? dati.nomeFile : ''
        this.$emit('onLoaded', dati)
        this.localLoading = false
      },
      onLoadedArray(dati, tipo) {
        const nn = dati.nomeFile.split('.')
        nn.pop()
        const settore = nn.join('.')
        const infoImport = {
          data: this.dataLettura,
          settore: settore,
          note: this.noteLettura,
          nomeFile: dati.nomeFile,
          tipoFile: tipo,
          totaleDati: dati.datiRaw.length, 
          datiRaw: dati.datiRaw
        }
        this.$emit('importaArray', infoImport)
        this.localLoading = false
      },
      onPulisci() {
        // this.modelloProdotto = null
        this.triggerReset++
        this.settore = null
        this.noteLettura = ''
        this.$emit('onLoaded', null)
      },
      onImporta() {
        this.dialogConferma = true
      },
      eseguiImporta() {
         const infoImport = {
          data: this.dataLettura,
          settore: this.settore,
          note: this.noteLettura,
          nomeFile: this.nomeFile,
          tipoFile: this.tipoFile
        }
        this.$emit('importa', infoImport)
        this.dialogConferma = false
      },
      onChangeSettore() {
        if (this.settore && !this.settoriInseriti.includes(this.settore)) {
          this.settoriInseriti.push(this.settore)
        }
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      onCercaMovimenti(searchDate) {
        this.$emit('importMovimenti', searchDate)
      }
    }
  }
</script>
